module.exports = __webpack_public_path__ + "static/img/capacitacion.be5c273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/capacitacion.png
// module id = AVRQ
// module chunks = 9